export default "__VITE_ASSET__Cl3Wt4Ow__"